import React from 'react'
import PropTypes from 'prop-types'
import header from '../assets/bank-assets/background.jpg'
import headerArabic from '../assets/bank-assets/background-effaciliti.jpg'
import { useTranslation } from "react-i18next";

function Breadcrumbs({ children }) {
    const arr = Array.from(children);

    // eslint-disable-next-line
    const { t, i18n } = useTranslation();

    const changeLanguage = (language) => {
        i18n.changeLanguage(language);
    };

    return (
        <>
            {i18n.language === "fr" ? (
                <section className="bg-cover w-screen" style={{
                    backgroundImage: `url(${header})`
                }}>
                    <div className="tw-container py-8 md:py-16">
                        {
                            arr.map((child, i) => (
                                <span key={i}
                                    className={`text-xl md:text-xl lg:text-2xl tracking-wider capitalize ${arr.length - 1 !== i ? 'text-white font-light' : 'text-white font-semibold'}`}>
                                    {child}{(arr.length - 1) !== i ? ' / ' : ''}
                                </span>
                            ))
                        }
                    </div>
                </section>
            ) : (
                <section className="bg-cover w-screen" style={{
                    backgroundImage: `url(${header})`
                }}>
                    <div className="tw-container text-right py-8 md:py-16">
                        {
                            arr.reverse().map((child, i) => (
                                <span key={i}
                                    className={`text-xl md:text-xl lg:text-2xl tracking-wider capitalize ${arr.length - 1 !== i ? 'text-white font-light' : 'text-white font-semibold'}`}>
                                    {child}{(arr.length - 1) !== i ? ' / ' : ''}
                                </span>
                            ))
                        }
                    </div>
                </section>
            )}
        </>

    );
}

Breadcrumbs.propTypes = {
    children: PropTypes.node.isRequired
}

export default Breadcrumbs